import {
  CHECK_IN_FUNNEL_SCENARIO_ID,
  CompleteTemplateConfigType,
  DEFAULT_SCENARIO_ID,
  FAST_TRACK_SCENARIO_ID,
  PAYBYLINK_CUSTOMER_SUPPORT_SCENARIO_ID,
  PAYBYLINK_PTC_REDIRECTION_SCENARIO_ID,
  PAYBYLINK_VOUCHER_SCENARIO_ID,
  PROMO_CODE_WIDGET_SCENARIO_ID,
  ProductTemplateConfigType,
  TemplateProviderContextType,
  deepMerge,
} from '#src/utils';

import checkInFunnelConfig from './configs/checkingFunnel';
import DEFAULT_CONFIG from './configs/default';
import fastTrackConfig from './configs/fastTrack';
import {
  payByLinkCustomerSupportConfig,
  payByLinkPtcRedirectionConfig,
  payByLinkVoucherConfig,
} from './configs/paybylink';
import promoCodeWidgetConfig from './configs/promoCodeWidget';

type TemplatesPerScenarioConfigType = {
  [DEFAULT_SCENARIO_ID]: CompleteTemplateConfigType;
} & {
  [key: string]: ProductTemplateConfigType;
};

export const uppTemplatesPerScenarioConfig: TemplatesPerScenarioConfigType = {
  [DEFAULT_SCENARIO_ID]: DEFAULT_CONFIG,
  [PAYBYLINK_VOUCHER_SCENARIO_ID]: payByLinkVoucherConfig,
  [PAYBYLINK_PTC_REDIRECTION_SCENARIO_ID]: payByLinkPtcRedirectionConfig,
  [PAYBYLINK_CUSTOMER_SUPPORT_SCENARIO_ID]: payByLinkCustomerSupportConfig,
  [FAST_TRACK_SCENARIO_ID]: fastTrackConfig,
  [PROMO_CODE_WIDGET_SCENARIO_ID]: promoCodeWidgetConfig,
  [CHECK_IN_FUNNEL_SCENARIO_ID]: checkInFunnelConfig,
};

export const uppTemplatesPerScenarioConfigOptions = Object.keys(
  uppTemplatesPerScenarioConfig
);

const overrideTheDefaultConfig = (
  defaultConfig: CompleteTemplateConfigType,
  config: ProductTemplateConfigType
): CompleteTemplateConfigType => {
  return deepMerge(defaultConfig, config);
};

export const getTemplateConfigPerScenarioId = (
  scenarioId: string,
  templatesPerScenarioConfig: TemplatesPerScenarioConfigType
): TemplateProviderContextType => {
  if (
    !templatesPerScenarioConfig[scenarioId] ||
    scenarioId === DEFAULT_SCENARIO_ID
  ) {
    return {
      ...templatesPerScenarioConfig[DEFAULT_SCENARIO_ID],
      scenarioId: DEFAULT_SCENARIO_ID,
    };
  }

  const mergedConfig = overrideTheDefaultConfig(
    DEFAULT_CONFIG,
    templatesPerScenarioConfig[scenarioId]
  );

  return {
    ...mergedConfig,
    scenarioId,
  };
};

export const getUppTemplateConfigPerScenarioId = (
  scenarioId: string
): TemplateProviderContextType => {
  return getTemplateConfigPerScenarioId(
    scenarioId,
    uppTemplatesPerScenarioConfig
  );
};

export const uppScenarioIds = Object.keys(uppTemplatesPerScenarioConfig);
